import React from 'react';
import { ArrowRight, BookOpen, Globe } from 'lucide-react';

interface LandingCtaSectionProps {
  onNavigateToDashboard: () => void;
  onExploreDirectory?: () => void;
}

export const LandingCtaSection: React.FC<LandingCtaSectionProps> = ({
  onNavigateToDashboard,
  onExploreDirectory,
}) => {
  return (
    <section className="w-full max-w-7xl 2xl:max-w-[1536px] 3xl:max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-8 2xl:px-10 text-center">
      <div className="p-8 sm:p-10 2xl:p-12 rounded-3xl bg-gradient-to-b from-indigo-50/80 via-white to-slate-50 border border-indigo-100 shadow-xs space-y-5">
        <h3 className="text-2xl sm:text-3xl lg:text-4xl 2xl:text-5xl font-extrabold text-slate-900 tracking-tight leading-tight">
          Mulai Kelola & Dapatkan Nomor UIBN Buku Anda
        </h3>
        <p className="text-sm sm:text-base md:text-lg 2xl:text-xl text-slate-600 max-w-2xl 2xl:max-w-3xl mx-auto leading-relaxed">
          Akses direktori publik terbuka untuk mencari katalog buku terdaftar, atau masuk ke dashboard terintegrasi untuk mendaftarkan naskah baru.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3.5 pt-2">
          {onExploreDirectory && (
            <button
              type="button"
              onClick={onExploreDirectory}
              className="px-6 py-3.5 2xl:px-8 2xl:py-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs sm:text-sm 2xl:text-base font-semibold shadow-xs transition flex items-center gap-2 cursor-pointer"
            >
              <Globe className="w-4 h-4 2xl:w-5 2xl:h-5" />
              <span>Jelajahi Direktori Publik</span>
            </button>
          )}

          <button
            type="button"
            onClick={onNavigateToDashboard}
            className="px-6 py-3.5 2xl:px-8 2xl:py-4 bg-white hover:bg-slate-100 text-slate-700 border border-slate-200 rounded-xl text-xs sm:text-sm 2xl:text-base font-semibold transition flex items-center gap-2 cursor-pointer shadow-2xs"
          >
            <span>Masuk ke Dashboard Pengelolaan</span>
            <ArrowRight className="w-4 h-4 2xl:w-5 2xl:h-5 text-indigo-600" />
          </button>
        </div>
      </div>
    </section>
  );
};

